import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SoftwareInventoryTableColumn } from "./SoftwareInventoryTableColumn";

import { useSoftwareInventoryList } from "@hooks/inventory/softwareInventory/useSoftwareInventory";
import { SoftwareInventoriesResponseType } from "@type/inventory/software-inventory";
import { TablePagination } from "@helpers/tablePagination";

export default function SoftwareInventoryTable() {
  const { t } = useTranslation();

  const {
    softwareInventoriesListState: softwareInventoryListState,
    handleQuery,
  } = useSoftwareInventoryList();

  const { getData } = softwareInventoryListState;
  const { data, pagination } =
    getData || ({} as SoftwareInventoriesResponseType);

  return (
    <div className="mt-10">
      <Table
        columns={SoftwareInventoryTableColumn(t)}
        // actions={[
        //   {
        //     customIcon: (
        //       <ViewButton label="SOFTWARE_INVENTORY.TABLE.DETAILS_BUTTON_TEXT" />
        //     ),
        //     onClick: (id: string | number) => {
        //       navigate(`${id}`);
        //     },
        //   },
        // ]}
        rows={data || []}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
}
